import ModalConfirm from './ModalConfirm.vue'

export default (ctx, { content, contentHtml, warning, title, icon, cancel, yes, buttons, className }, options) => {
  cancel = cancel || {}
  yes = yes || {}
  // `name` lets the caller close it with $modal.hide(name); the rest sizes it.
  const { name, ...modalOptions } = options || {}
  modalOptions.height = modalOptions.height || 'auto'
  modalOptions.width = modalOptions.width || '475px'

  if (icon) {
    title = `<i class="${icon}"></i>${title}`
  }

  return new Promise((resolve) => {
    ctx.$modal.show(ModalConfirm, {
      title,
      content,
      contentHtml,
      warning,
      className,
      buttons: buttons || [
        {
          text: cancel.text || cancel.label || ctx.$t('fpui-modal-confirm.cancel'),
          color: cancel.color || 'white',
          type: 'close',
          handler () {
            this.$emit('close')
            return resolve(false)
          }
        },
        {
          text: yes.text || yes.label || ctx.$t('fpui-modal-confirm.yes'),
          autoWidth: yes.autoWidth || false,
          color: yes.color || 'green',
          handler () {
            this.$emit('close')
            return resolve(true)
          },
          id: yes.id
        }
      ]
    }, modalOptions, name ? { name } : {}, {
      // Escape, a click outside or a hide() answer no. After a button, this
      // second answer changes nothing.
      closed: () => resolve(false)
    })
  })
}
